import { render, staticRenderFns } from "./time-line.vue?vue&type=template&id=644396c5&scoped=true&"
import script from "./time-line.vue?vue&type=script&lang=js&"
export * from "./time-line.vue?vue&type=script&lang=js&"
import style0 from "./time-line.vue?vue&type=style&index=0&id=644396c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644396c5",
  null
  
)

export default component.exports